import {RegexValidator} from "./RegexValidators";

export class PostalCodeValidator extends RegexValidator {
    constructor(input) {
        const regex = new RegExp("^\\d{8}$");
        super(input, regex);
    }
    isValid() {
        if(this.input.toString().length >= 8 && !this.input.toString().match("_")) {
            return this.regex.test(this.input.toString().replace("-", ""));
        }
        return false;
    }
    message() {
        return !this.isValid() ? "CEP inválido" : "OK";
    }
}


// WEBPACK FOOTER //
// ./src/validator/AddressValidators.js